import React from 'react';
import Feature from '../../common/Feature';
import config from '../../../config';

const Protection = () => {
	return (
		<section className="row features">
			<div className="col">
				<h2 className="title">Protection and Convenience</h2>
			</div>
			<div className="callouts">
				<Feature
					title="Locking Drawer"
					description="Designed to fit within your safe, this feature provides added security for items that are especially important or fragile, as well as the ability to lock out those who are allowed access to the rest of the safe."
					image={require('../../../resources/img/features/locking-drawer.png')}
				/>
				<Feature
					title="Interior Lighting"
					description="Interior lighting provides increased visibility in dimly lit locations, so you can easily access without additional lighting."
					image={require('../../../resources/img/features/interior-lighting.png')}
				/>
				{/* <Feature
					title="USB Connectivity"
					description="Keep USB drives and portable hard drives secure while in use in your locked safe."
					image={ require('../../../resources/img/features/usb-connection.png') }
				/> */}
				<Feature
					title="Carrying Handle"
					description="Make moving your safe, chest or file easy with a convenient carrying handle."
					image={require('../../../resources/img/features/carrying-handle.png')}
				/>
				<Feature
					title="Digital Media"
					description="Protect tablets, phones, external hard drives, memory cards, USB drives, CDs, DVDs and other electronic storage devices."
					image={`${config.contentUrl}/sentrysafe/features/FP_DigitalMedia.png`}
				/>
				<Feature
					title="Soft Interior Lining"
					description="Ensures your fragile or delicate valuables are protected from scratches."
					image={require('../../../resources/img/features/interior-lining.png')}
				/>
			</div>
		</section>
	);
};

export default Protection;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Protection.js